import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function ClusterGridFilter() {
    const [filterCdCluster, setFilterCdCluster] = useState<FilterValuesProps>({
        property: 'cdClusterLoja',
        operator: 'like',
        value: null,
        idProperty: 'cdClusterLoja',
    });

    const [filterDsCluster, setFilterDsCluster] = useState<FilterValuesProps>({
        property: 'dsClusterLoja',
        operator: 'like',
        value: null,
        idProperty: 'dsClusterLoja',
    });

    const [filterFgAtivo, setFilterFgAtivo] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'eq',
        value: null,
        idProperty: 'vlStatus',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterCdCluster, setter: setFilterCdCluster },
                { value: filterDsCluster, setter: setFilterDsCluster },
                { value: filterFgAtivo, setter: setFilterFgAtivo },
            ]}
        >
            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Código"
                    value={filterCdCluster.value}
                    onChange={(e) => setFilterCdCluster((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>

            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Descrição"
                    value={filterDsCluster.value}
                    onChange={(e) => setFilterDsCluster((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>

            <Grid sx={{ flex: 4 }}>
                <StatusField
                    value={filterFgAtivo.value}
                    onChange={(e, value) => setFilterFgAtivo((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
        </Filter>
    );
}
